import { PlayStateContext } from "play/context/play-context"
import { useContext } from "react"

export function usePlayState() {
  return useContext(PlayStateContext)
}
